import Vue from 'vue'
import App from './App.vue'
import router from './router'
import yyHeader from './components/yy-header.vue'
import yyFooter from './components/yy-footer.vue'
import Search from './components/search.vue'
import DatetimePicker from 'vant/lib/datetime-picker'
import Toast from 'vant/lib/toast'// Toast
import List from 'vant/lib/list'// list
import Dialog from 'vant/lib/dialog'// list
import Swipe from 'vant/lib/swipe'
import SwipeItem from 'vant/lib/swipe-item'
import Popup from 'vant/lib/popup'
import { Card } from 'vant';
import Form from 'vant/lib/form'
import Field from 'vant/lib/field'
import wx from 'weixin-js-sdk'
// eslint-disable-next-line import/no-duplicates
import { Picker , Overlay ,Loading } from 'vant'
// eslint-disable-next-line import/no-duplicates
import { Icon } from 'vant'
import { Collapse, CollapseItem } from 'vant';
import {Divider } from 'vant';

// import my from 'https://appx/web-view.min.js'
import 'vant/lib/datetime-picker/style'
import 'vant/lib/toast/style'
import 'vant/lib/list/style'
import 'vant/lib/dialog/style'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'
import 'vant/lib/popup/style'
import 'vant/lib/form/style'
import 'vant/lib/field/style'
import 'vant/lib/divider/style'
// 引入fastclick解决移动端click事件300毫秒延迟
import fastClick from 'fastclick'

// http://10.1.8.146:8000/
import axios from 'axios'

// 初始化样式
import './assets/less/reset.less'
// 设置axios的全局默认地址
// axios.defaults.baseURL = '/yuyue'
// 将axios挂载到vue的原型上
Vue.prototype.$axios = axios
// 添加请求拦截器
// axios.interceptors.request.use(config => {
//   // 在发送请求之前做些什么
//   config.headers.Authorization = localStorage.getItem('token')
//   return config
// }, error => {
//   // 对请求错误做些什么
//   return Promise.reject(error)
// })

// 添加响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做点什么
  response = response.data
  return response
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error)
})
// 将fastclick绑定到body上
fastClick.attach(document.body)

Vue.config.productionTip = false
Vue.use(DatetimePicker)
Vue.use(Toast)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Picker)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Card);
Vue.use(Overlay);
Vue.use(Loading);
Vue.use(Form);
Vue.use(Field);
Vue.use(Divider);
Vue.prototype.wx = wx
Vue.config.devtools = true

Vue.component('yy-header', yyHeader)
Vue.component('yy-footer', yyFooter)
Vue.component('search', Search)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
